/* tslint:disable */
/* eslint-disable */
/**
 * MCP Manager API
 * API for managing Model Context Protocol (MCP) connections
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScopeFromJSON, ScopeToJSON, } from './Scope';
import { AuthDataComposioManagedFromJSON, AuthDataComposioManagedToJSON, } from './AuthDataComposioManaged';
import { AuthStatusFromJSON, AuthStatusToJSON, } from './AuthStatus';
import { AuthTypeFromJSON, AuthTypeToJSON, } from './AuthType';
/**
 * Check if a given object implements the AuthResponse interface.
 */
export function instanceOfAuthResponse(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined)
        return false;
    if (!('created_at' in value) || value['created_at'] === undefined)
        return false;
    if (!('global_id' in value) || value['global_id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('app' in value) || value['app'] === undefined)
        return false;
    if (!('scopes' in value) || value['scopes'] === undefined)
        return false;
    return true;
}
export function AuthResponseFromJSON(json) {
    return AuthResponseFromJSONTyped(json, false);
}
export function AuthResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'status': AuthStatusFromJSON(json['status']),
        'data': AuthDataComposioManagedFromJSON(json['data']),
        'updated_at': json['updated_at'],
        'created_at': json['created_at'],
        'global_id': json['global_id'],
        'type': AuthTypeFromJSON(json['type']),
        'app': json['app'],
        'scopes': (json['scopes'].map(ScopeFromJSON)),
    };
}
export function AuthResponseToJSON(json) {
    return AuthResponseToJSONTyped(json, false);
}
export function AuthResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'status': AuthStatusToJSON(value['status']),
        'data': AuthDataComposioManagedToJSON(value['data']),
        'updated_at': value['updated_at'],
        'created_at': value['created_at'],
        'global_id': value['global_id'],
        'type': AuthTypeToJSON(value['type']),
        'app': value['app'],
        'scopes': (value['scopes'].map(ScopeToJSON)),
    };
}
